"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var SimpleList = react_1.forwardRef(function SimpleList(_a, ref) {
    var data = _a.data, _b = _a.divideAll, divideAll = _b === void 0 ? true : _b, listProps = __rest(_a, ["data", "divideAll"]);
    var preparedData = data === null || data === void 0 ? void 0 : data.map(function (item) {
        if (typeof item === 'string') {
            return {
                key: item,
                primary: item,
            };
        }
        return item;
    });
    var items = preparedData === null || preparedData === void 0 ? void 0 : preparedData.map(function (_a, index) {
        var key = _a.key, primary = _a.primary, secondary = _a.secondary, icon = _a.icon, trailingIcon = _a.trailingIcon, divider = _a.divider, button = _a.button, listItemProps = __rest(_a, ["key", "primary", "secondary", "icon", "trailingIcon", "divider", "button"]);
        return (jsx_runtime_1.jsx(core_1.ListItem, __assign({ 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            button: (button !== undefined ? button : listItemProps.onClick !== undefined), divider: divider || (divideAll && index + 1 !== preparedData.length) }, listItemProps, { children: jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [Boolean(icon) && jsx_runtime_1.jsx(core_1.ListItemIcon, { children: icon }, void 0),
                    jsx_runtime_1.jsx(core_1.ListItemText, { primary: primary, secondary: secondary }, void 0),
                    Boolean(trailingIcon) && jsx_runtime_1.jsx(core_1.ListItemIcon, { children: trailingIcon }, void 0)] }, void 0) }), key || ((primary === null || primary === void 0 ? void 0 : primary.toString()) || '') + index));
    });
    return (jsx_runtime_1.jsx(core_1.List, __assign({}, listProps, { ref: ref }, { children: items }), void 0));
});
exports.default = SimpleList;
//# sourceMappingURL=SimpleList.js.map